import { FC } from 'react';

import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import DiagramCard from 'portfolio3/features/diagnostics/DiagramCard';
import { accentColors, NeutralColors } from 'portfolio3/styles';
import { commonTheme } from 'portfolio3/styles/theme';
import { PercentDoughnut } from 'portfolio3/ui-kit';
import { getDiagnosticPercentColor, getMarkPluralization, prettifyNumber } from 'utils';

import * as styles from './styles';

interface IPersonalBestResultDiagramProps {
  subject: string;
  score: number;
  scorePercent: number;
  date: string;
}

const PersonalBestResultDiagram: FC<IPersonalBestResultDiagramProps> = ({ subject, score, scorePercent, date }) => {
  const isSmallScreen = useMediaQuery(commonTheme.breakpoints.down('commonSm'));

  const prettyScorePercent = prettifyNumber(scorePercent, { precision: 1 });
  const pluralizedBall = getMarkPluralization(score);

  const percentColor = getDiagnosticPercentColor(scorePercent, [
    accentColors.red[80],
    accentColors.orange[80],
    accentColors.yellow[80],
    accentColors.lime[80],
  ]);

  const doughnutElement = (
    <Box sx={styles.doughnutContainer}>
      <PercentDoughnut percent={scorePercent} color={percentColor} />
      <Typography variant="Headings/H6" position="absolute">
        {prettyScorePercent}%
      </Typography>
    </Box>
  );

  const descriptionElement = (
    <Stack gap="8px">
      <Typography variant={isSmallScreen ? 'Paragraph MD/Semi Bold' : 'Paragraph LG/Semi Bold'}>{subject}</Typography>
      <Typography variant={isSmallScreen ? 'Paragraph MD/Regular' : 'Paragraph LG/Regular'}>
        {score} {pluralizedBall}
      </Typography>
      <Typography
        variant={isSmallScreen ? 'Paragraph MD/Regular' : 'Paragraph LG/Regular'}
        color={NeutralColors.light_neutrals_600}
      >
        {date}
      </Typography>
    </Stack>
  );

  return (
    <DiagramCard title="Твой лучший результат" sx={styles.root}>
      <Box sx={styles.container}>
        {doughnutElement}
        {descriptionElement}
      </Box>
    </DiagramCard>
  );
};

export default PersonalBestResultDiagram;
